import { Button, Divider, Form, Grid, Input, InputNumber, Space } from "@arco-design/web-react";
import { copy } from "../utils/copy";
import { IconCopy } from "@arco-design/web-react/icon";
import React, { useEffect, useState } from "react";
import { check } from "../utils/check";
import { toHValue } from "../utils/wrap";

const FormItem = Form.Item;
const Row = Grid.Row;
const Col = Grid.Col;
const ArcCalculation = () => {
  const [btnState0, setBtnState0] = useState({ calc: false, reset: false });
  const [btnState1, setBtnState1] = useState({ calc: false, reset: false });
  const [btnState2, setBtnState2] = useState({ calc: false, reset: false });
  const [form0] = Form.useForm();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const STORAGE_KEY = "arc_values_v1";
  const loadAll = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  };
  const saveAll = (data) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {}
  };
  const persist = () => {
    const data = loadAll();
    data.form0 = { ...(form0.getFieldsValue?.() || {}) };
    data.form1 = { ...(form1.getFieldsValue?.() || {}) };
    data.form2 = { ...(form2.getFieldsValue?.() || {}) };
    saveAll(data);
  };
  useEffect(() => {
    const saved = loadAll();
    if (saved.form0) form0.setFieldsValue(saved.form0);
    if (saved.form1) form1.setFieldsValue(saved.form1);
    if (saved.form2) form2.setFieldsValue(saved.form2);
    if (saved.form0) setBtnState0(check(saved.form0, 2));
    if (saved.form1) setBtnState1(check(saved.form1, 2));
    if (saved.form2) setBtnState2(check(saved.form2, 2));
  }, []);
  const onSubmitR = () => {
    const { R1, R2 } = form0.getFieldsValue();
    const R = Number(R1) + Number(R2);
    const value = toHValue(R);
    form0.setFieldValue("R", value);
    if (typeof value === "number") {
      form1.setFieldValue("R", value);
      form2.setFieldValue("R", value);
    }
    persist();
  };
  const onSubmitOne = () => {
    const { X, R } = form1.getFieldsValue();
    const Z = Math.sqrt(R * X - Math.pow(X, 2) / 4);
    form1.setFieldValue("Z", toHValue(Z));
    persist();
  };
  const onSubmitTwo = () => {
    const { Z, R } = form2.getFieldsValue();
    const X = 2 * (R - Math.sqrt(Math.pow(R, 2) - Math.pow(Z, 2)));
    form2.setFieldValue("X", toHValue(X));
    persist();
  };
  return (
    <>
      {document.body.clientWidth <= 1080 ? (
        <div className="cpn-wrapper-vertical">
          <Form
            style={{ maxWidth: 300, width: "90%" }}
            autoComplete="off"
            form={form0}
            onSubmit={onSubmitR}
            colon=":"
            layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
            onValuesChange={(_, values) => {
              setBtnState0(check(values, 2));
              persist();
            }}
          >
            <FormItem
              label="滚轮 R1"
              field="R1"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min={0} size="large" />
            </FormItem>
            <FormItem
              label="工件 R2"
              field="R2"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min={0} size="large" />
            </FormItem>
            <FormItem wrapperCol={{ offset: 5 }}>
              <Space>
                <Button type="primary" htmlType="submit" disabled={!btnState0.calc}>
                  立即计算
                </Button>
                <Button onClick={() => { form0.resetFields(); const data = loadAll(); data.form0 = {}; saveAll(data); setBtnState0({calc:false, reset:false}); }} disabled={!btnState0.reset}>
                  重置
                </Button>
              </Space>
            </FormItem>
            <FormItem label="R" field="R">
              <Input
                id="result_ac_r"
                size="large"
                readOnly
                onClick={copy}
                placeholder="计算结果在此次显示"
                disabled={!btnState0.calc || form0.getFieldValue("R") === "非法条件"}
                suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_ac_r")} />}
              />
            </FormItem>
          </Form>
          <Divider />
          <Form
            style={{ maxWidth: 300, width: "90%" }}
            autoComplete="off"
            form={form1}
            onSubmit={onSubmitOne}
            colon=":"
            layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
            onValuesChange={(_, values) => {
              setBtnState1(check(values, 2));
              persist();
            }}
          >
            <FormItem label="X" field="X" rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}>
              <InputNumber min={0} size="large" />
            </FormItem>
            <FormItem label="R" field="R" rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}>
              <InputNumber min={0} size="large" />
            </FormItem>
            <FormItem wrapperCol={{ offset: 5 }}>
              <Space>
                <Button type="primary" htmlType="submit" disabled={!btnState1.calc}>
                  立即计算
                </Button>
                <Button onClick={() => { form1.resetFields(); const data = loadAll(); data.form1 = {}; saveAll(data); setBtnState1({calc:false, reset:false}); }} disabled={!btnState1.reset}>
                  重置
                </Button>
              </Space>
            </FormItem>
            <FormItem label="Z" field="Z">
              <Input
                id="result_ac_z"
                size="large"
                readOnly
                onClick={copy}
                disabled={!btnState1.calc || form1.getFieldValue("Z") === "非法条件"}
                placeholder="计算结果在此次显示"
                suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_ac_z")} />}
              />
            </FormItem>
          </Form>
          <Divider />
          <Form
            style={{ maxWidth: 300, width: "90%" }}
            autoComplete="off"
            form={form2}
            onSubmit={onSubmitTwo}
            colon=":"
            layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
            onValuesChange={(_, values) => {
              setBtnState2(check(values, 2));
              persist();
            }}
          >
            <FormItem label="Z" field="Z" rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}>
              <InputNumber min={0} size="large" />
            </FormItem>
            <FormItem label="R" field="R" rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}>
              <InputNumber min={0} size="large" />
            </FormItem>
            <FormItem wrapperCol={{ offset: 5 }}>
              <Space>
                <Button type="primary" htmlType="submit" disabled={!btnState2.calc}>
                  立即计算
                </Button>
                <Button onClick={() => { form2.resetFields(); const data = loadAll(); data.form2 = {}; saveAll(data); setBtnState2({calc:false, reset:false}); }} disabled={!btnState2.reset}>
                  重置
                </Button>
              </Space>
            </FormItem>
            <FormItem label="X" field="X">
              <Input
                id="result_ac_x"
                size="large"
                readOnly
                onClick={copy}
                placeholder="计算结果在此次显示"
                disabled={!btnState2.calc || form2.getFieldValue("X") === "非法条件"}
                suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_ac_x")} />}
              />
            </FormItem>
          </Form>
        </div>
      ) : (
        <>
          <div className="cpn-wrapper-horizontal">
            <Row style={{ width: 1280 }} gutter={20}>
              <Col span={12}>
                <Form
                  style={{ maxWidth: 300, width: "90%" }}
                  autoComplete="off"
                  form={form1}
                  onSubmit={onSubmitOne}
                  colon=":"
                  layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
                  onValuesChange={(_, values) => { setBtnState1(check(values, 2)); persist(); }}
                >
                  <FormItem
                    label="X"
                    field="X"
                    rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
                  >
                    <InputNumber min={0} size="large" />
                  </FormItem>
                  <FormItem
                    label="R"
                    field="R"
                    rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
                  >
                    <InputNumber min={0} size="large" />
                  </FormItem>
                  <FormItem wrapperCol={{ offset: 5 }}>
                    <Space>
                      <Button type="primary" htmlType="submit" disabled={!btnState1.calc}>
                        立即计算
                      </Button>
                      <Button onClick={() => { form1.resetFields(); const data = loadAll(); data.form1 = {}; saveAll(data); setBtnState1({calc:false, reset:false}); }} disabled={!btnState1.reset}>
                        重置
                      </Button>
                    </Space>
                  </FormItem>
                  <FormItem label="Z" field="Z">
                    <Input
                      id="result_ac_z"
                      size="large"
                      readOnly
                      onClick={copy}
                      disabled={!btnState1.calc || form1.getFieldValue("Z") === "非法条件"}
                      placeholder="计算结果在此次显示"
                      suffix={
                        <IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_ac_z")} />
                      }
                    />
                  </FormItem>
                </Form>
              </Col>
              <Col span={12}>
                <Form
                  style={{ maxWidth: 300, width: "90%" }}
                  autoComplete="off"
                  form={form2}
                  onSubmit={onSubmitTwo}
                  colon=":"
                  layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
                  onValuesChange={(_, values) => { setBtnState2(check(values, 2)); persist(); }}
                >
                  <FormItem
                    label="Z"
                    field="Z"
                    rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
                  >
                    <InputNumber min={0} size="large" />
                  </FormItem>
                  <FormItem
                    label="R"
                    field="R"
                    rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
                  >
                    <InputNumber min={0} size="large" />
                  </FormItem>
                  <FormItem wrapperCol={{ offset: 5 }}>
                    <Space>
                      <Button type="primary" htmlType="submit" disabled={!btnState2.calc}>
                        立即计算
                      </Button>
                      <Button onClick={() => { form2.resetFields(); const data = loadAll(); data.form2 = {}; saveAll(data); setBtnState2({calc:false, reset:false}); }} disabled={!btnState2.reset}>
                        重置
                      </Button>
                    </Space>
                  </FormItem>
                  <FormItem label="X" field="X">
                    <Input
                      id="result_ac_x"
                      size="large"
                      readOnly
                      onClick={copy}
                      placeholder="计算结果在此次显示"
                      disabled={!btnState2.calc || form2.getFieldValue("X") === "非法条件"}
                      suffix={
                        <IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_ac_x")} />
                      }
                    />
                  </FormItem>
                </Form>
              </Col>
            </Row>
          </div>
          <Divider />
          <Form
            style={{ maxWidth: 300, width: "90%" }}
            autoComplete="off"
            form={form0}
            onSubmit={onSubmitR}
            colon=":"
            layout={document.body.clientWidth <= 780 ? "vertical" : "horizontal"}
            onValuesChange={(_, values) => { setBtnState0(check(values, 2)); persist(); }}
          >
            <FormItem
              label="滚轮 R1"
              field="R1"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min={0} size="large" />
            </FormItem>
            <FormItem
              label="工件 R2"
              field="R2"
              rules={[{ validator: (value, cb) => (value > 0 ? cb() : cb("此项必填且大于 0!")) }]}
            >
              <InputNumber min={0} size="large" />
            </FormItem>
            <FormItem wrapperCol={{ offset: 5 }}>
              <Space>
                <Button type="primary" htmlType="submit" disabled={!btnState0.calc}>
                  立即计算
                </Button>
                <Button onClick={() => { form0.resetFields(); const data = loadAll(); data.form0 = {}; saveAll(data); setBtnState0({calc:false, reset:false}); }} disabled={!btnState0.reset}>
                  重置
                </Button>
              </Space>
            </FormItem>
            <FormItem label="R" field="R">
              <Input
                id="result_ac_r"
                size="large"
                readOnly
                onClick={copy}
                placeholder="计算结果在此次显示"
                disabled={!btnState0.calc || form0.getFieldValue("R") === "非法条件"}
                suffix={<IconCopy style={{ cursor: "pointer" }} onClick={copy.bind(null, null, "#result_ac_r")} />}
              />
            </FormItem>
          </Form>
        </>
      )}
    </>
  );
};
export default ArcCalculation;
